import { c as _c } from "react/compiler-runtime";
import LiveBadge from '@pc/components/badge/LiveBadge';
import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
const HOVER_BRIDGE_WIDTH = 6;
const POPUP_WIDTH = 211;
interface BJListItemProps {
  isLive?: boolean;
  onClick: () => void;
  title?: string;
  userImg: string;
  userNick: string;
}
function BJListItem(t0) {
  const $ = _c(26);
  const {
    isLive: t1,
    onClick,
    title: t2,
    userImg,
    userNick
  } = t0;
  const isLive = t1 === undefined ? false : t1;
  const title = t2 === undefined ? "" : t2;
  const [coords, setCoords] = useState(null);
  const itemRef = useRef(null);
  const popupAreaRef = useRef(null);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = relatedTarget => {
      if (!(relatedTarget instanceof Node)) {
        return false;
      }
      return itemRef.current?.contains(relatedTarget) === true || popupAreaRef.current?.contains(relatedTarget) === true;
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const isMovingInsideSharedHoverArea = t3;
  let t4;
  let t5;
  if ($[1] !== coords) {
    t4 = () => {
      if (!coords) {
        return;
      }
      const handleScroll = () => {
        setCoords(null);
      };
      window.addEventListener("scroll", handleScroll, true);
      return () => {
        window.removeEventListener("scroll", handleScroll, true);
      };
    };
    t5 = [coords];
    $[1] = coords;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  useEffect(t4, t5);
  let t6;
  if ($[4] !== onClick) {
    t6 = () => {
      onClick();
    };
    $[4] = onClick;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event => {
      const rect = event.currentTarget.getBoundingClientRect();
      setCoords({
        top: rect.top - 4,
        left: rect.right - 2
      });
    };
    t8 = event_0 => {
      if (isMovingInsideSharedHoverArea(event_0.relatedTarget)) {
        return;
      }
      setCoords(null);
    };
    $[6] = t7;
    $[7] = t8;
  } else {
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] !== userImg) {
    t9 = <div className="h-6 w-6 shrink-0 overflow-hidden rounded-full border border-transparent "><img width={24} height={24} src={userImg} className="min-h-6 min-w-6 rounded-full object-cover" alt="" /></div>;
    $[8] = userImg;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== userNick) {
    t10 = <div className="flex flex-1 overflow-hidden"><span className="inline-flex max-w-[100px] overflow-hidden align-top"><span className="overflow-hidden truncate text-[15px] leading-[21px]">{userNick}</span></span></div>;
    $[10] = userNick;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== isLive) {
    t11 = isLive && <div className="relative h-[14px] w-[28px] shrink-0"><LiveBadge className="relative" style={{
        fontSize: 28
      }} /></div>;
    $[12] = isLive;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== coords || $[15] !== isLive || $[16] !== onClick || $[17] !== title || $[18] !== userNick) {
    t12 = coords && isLive && typeof document !== "undefined" && createPortal(<div ref={popupAreaRef} className="fixed z-50" style={{
      top: coords.top,
      left: coords.left,
      width: POPUP_WIDTH + HOVER_BRIDGE_WIDTH
    }} onMouseLeave={event_1 => {
      if (isMovingInsideSharedHoverArea(event_1.relatedTarget)) {
        return;
      }
      setCoords(null);
    }}><button type="button" className="flex w-[211px] flex-col items-start gap-1 rounded-[10px] border border-borderBg14 bg-baseBg px-4 py-2 text-left shadow-[0_4px_8px_rgba(0,0,0,0.25)]" style={{
        marginLeft: HOVER_BRIDGE_WIDTH
      }} onClick={() => {
        onClick();
        setCoords(null);
      }}><div className="line-clamp-1 font-bold text-[#04a1d4] text-[14px] leading-[20px] tracking-[-0.5px]">{userNick}</div><div className="line-clamp-2 w-full overflow-hidden break-all text-[13px] text-baseFg leading-[19px] tracking-[-0.5px]">{title}</div></button></div>, document.body);
    $[14] = coords;
    $[15] = isLive;
    $[16] = onClick;
    $[17] = title;
    $[18] = userNick;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t12 || $[23] !== t6 || $[24] !== t9) {
    t13 = <li ref={itemRef} className="flex h-[50px] w-full items-center gap-6 rounded-[10px] px-[17px] text-[15px] tracking-[-0.5px] hover:cursor-pointer hover:bg-colorBg01" onClick={t6} onMouseEnter={t7} onMouseLeave={t8}>{t9}{t10}{t11}{t12}</li>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
    $[23] = t6;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}
export default BJListItem;